module.exports = {
          srcSet: __webpack_public_path__ + "d31c5592.jpg"+" 700w"+","+__webpack_public_path__ + "e3bec749.jpg"+" 1400w"+","+__webpack_public_path__ + "2878707a.jpg"+" 2000w",
          images:[ {path: __webpack_public_path__ + "d31c5592.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "e3bec749.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "2878707a.jpg",width: 2000,height: 1500}],
          src: __webpack_public_path__ + "d31c5592.jpg",
          toString:function(){return __webpack_public_path__ + "d31c5592.jpg"},
          
          width: 700,
          height: 525
        }